import { Button, Icon, message, Row, Typography, Upload, Select } from "antd";
import { ReactComponent as Logoo } from "./Svgs/Language.svg";
import React, { useState } from 'react'
const { Text } = Typography;
const { Option } = Select;

export default function AddLanguageModalContent(props) {
  const { closeModal } = props;
  const [StoreImageFile, setStoreImageFile] = useState(null);
  const [countries, setCountries] = useState(["wrwwr", "sfvsfv", "svfsdv", "sfgtgtgt"]);

  return (
    <div>
      <Row className="modal-row">
        <Row>
          <div style={{ display: "flex" }}>
            <div>
              <Logoo style={{ marginTop: "2px" }} />
            </div>
            <Text
              style={{
                marginLeft: "16px",
                fontWeight: "700",
                color: "#181818",
                fontSize: "24px",
                fontStyle: "normal",
                lineHeight: "40px",
              }}>
              Add a new Language
            </Text>
          </div>
        </Row>
        <div style={{ margin: "16px 0px", background: "#E8E8E8", height: "1px" }}></div>
        <Row className="stores_wrapper" >
          <div>
            <div
              style={{
                // marginTop: "32px",
                width: "100%",
              }}>
              <Text
                style={{
                  fontSize: "14px",
                  color: "#181818",
                  fontWeight: "bold",
                  // fontWeight:"bold"
                }}>
                Select language
              </Text>
              <Select
                defaultValue={"United Arab Emirates"}
                className="time-value-cohort-col-main-element"
                style={{ width: "100%", marginTop: "4px" }}
                placeholder="Select language"
                name="country"
                // value={storelocation.country}
                onChange={(value) => {
                  // setStorelocation({
                  //     ...storelocation,
                  //     ["country"]: value,
                  // });
                }}>
                {countries.map((country) => {
                  return (
                    <Option value={country}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {country}
                      </div>
                    </Option>
                  );
                })}
              </Select>
            </div>

            <Row className="image-upload-row" style={{ marginTop: "32px" }}>
              <React.Fragment>
                <div className="image-upload-col" style={{ padding: "0" }}>
                  <Text
                    style={{
                      fontSize: "14px",
                      color: "#181818",
                      fontWeight: "bold",
                    }}>
                    Upload Language List
                  </Text>
                  <div
                    style={{
                      marginTop: "12px",
                      // width: "610px",
                      border: "1px solid rgb(0, 0, 0, 0.25)",
                      borderRadius: "5px",
                      background: "transparent",
                    }}
                    className="image-upload-container">
                    <Upload
                      className={StoreImageFile === null ? "upload-class" : "upload-class-none"}
                      name="file"
                      // accept=".jpg ,"
                      listType={"picture-card"}
                      beforeUpload={(file) => {
                        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
                        if (!isJpgOrPng) {
                          message.error("You can only upload JPG/PNG file!");
                        }
                        const isLt2M = file.size / 1024 / 1024 < 2;
                        if (!isLt2M) {
                          message.error("Image must smaller than 2MB!");
                        }
                        return isJpgOrPng && isLt2M;
                      }}
                      onRemove={() => {
                        // setStoreImageFile(null);
                      }}
                      multiple={false}
                      style={{
                        marginTop: "8px",
                        width: "100%",
                        border: "1px solid rgb(0, 0, 0, 0.25)",
                        borderRadius: "5px",
                        background: "transparent",
                      }}
                      // bordered={true}
                      showUploadList={{
                        // showPreviewIcon: false,
                      }}
                      customRequest={({ file, onSuccess }) => {
                        setTimeout(() => {
                          onSuccess("ok");
                        }, 0);
                      }}
                      onChange={(info) => {
                        // const { status } = info.file;
                        // if (status === "done") {
                        //     if (info.fileList.length >= 2) info.fileList.shift();
                        //     // console.log(info);

                        //     setStoreImageFile(info.fileList[0]?.originFileObj);
                        // } else if (status === "error") {
                        //     message.error(`${info.file.name} file upload failed.`);
                        // } else if (status === "removed") {
                        //     setStoreImageFile(null);
                        // } else if (!status) {
                        //     info.fileList.pop();
                        // }
                      }}
                      defaultFileList={StoreImageFile ? [StoreImageFile] : []}>
                      {StoreImageFile == null ? (
                        <>
                          <Row type="flex" justify="center" align="middle" style={{ flexDirection: "column" }}>
                            <Icon
                              type="cloud-upload"
                              style={{
                                color: "#E5E5E5",
                                fontSize: "48px",
                                marginTop: "25px",
                                marginBottom: "24px",
                              }}
                            />
                            <Text
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: "14px",
                                lineHeight: "22px",
                                color: "#181818",
                                marginBottom: 8,
                              }}>
                              Drag & drop file or browse image to upload
                            </Text>
                          </Row>
                        </>
                      ) : (
                        <></>
                      )}
                    </Upload>
                  </div>
                </div>
              </React.Fragment>
            </Row>
          </div>

          <div
            style={{
              marginTop: "24px ",
              background: "#E8E8E8",
              height: "1px",
            }}></div>
          <Row
            type="flex"
            justify="end"
            align="middle"
            style={{
              marginTop: "32px",
            }}>
            <Button
              size="large"
              style={{
                height: "40px",
                boxShadow: "none",
                borderRadius: "20px",
                border: "none",
                backgroundColor: "#FFFFFF",
                color: "#181818",
                marginRight: "12px",
              }}
              onClick={() => {
                closeModal()
              }}
            >
              Cancel
            </Button>
            <Button
              size="large"
              style={{
                height: "40px",
                borderRadius: "5px",
                border: "none",
                backgroundColor: "#fec708",
                color: "#FFFFFF",
              }}
              onClick={() => {
                // addStore(setStoreDeatils, storeDetails, storelocation, StoreImageFile, setaddModal, loadTable);
              }}>
              Add Language
            </Button>
          </Row>
        </Row>
      </Row>
    </div>
  )
}
